import { useEffect, useState } from "react";
import { navItems } from "@/mocks/cg51";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const bar = scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent border-b border-transparent";

  return (
    <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${bar}`}>
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        {/* 品牌 */}
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 font-heading text-base font-black text-accent-400">
            51
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            cg<span className="text-primary-600">51</span>
          </span>
        </a>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-800"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {/* 搜索框 */}
          <div className="relative hidden lg:block">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜索热门话题 / 分区"
              className="w-56 rounded-full border border-background-200 bg-background-50 py-2 pl-9 pr-4 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400"
            />
          </div>
          <button
            type="button"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            开始逛 cg51
          </button>
          {/* 汉堡 */}
          <button
            type="button"
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-900 md:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {/* 移动菜单 */}
      {open ? (
        <nav className="border-t border-background-200 bg-background-50/95 px-4 py-3 backdrop-blur md:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md bg-background-100 px-4 py-2.5 text-center text-sm font-medium text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            className="mt-3 w-full whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
          >
            开始逛 cg51
          </button>
        </nav>
      ) : null}
    </header>
  );
}